import { fetchParameterConferenceHub } from '@/api/business/processhub'
import { useQuery } from '@tanstack/react-query'

export const ParameterConferenceHubKeys = {
    all: ['parameterconferencehub'] as const, 
    lists: () => [...ParameterConferenceHubKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ParameterConferenceHubKeys.lists(), page, perPage, filters] as const,
}

export const useParameterConferenceHubQuery = () => {
    return useQuery({
        queryFn: () => fetchParameterConferenceHub(),
        queryKey: ParameterConferenceHubKeys.lists()
    })
}
